<template>
    <el-cascader style="width: 100%" :options="areaSource" :value="value"  filterable v-bind="$attrs"
                 :collapse-tags="collapse" v-on="$listeners"></el-cascader>
</template>

<script>
    import {regionData, CodeToText} from 'element-china-area-data';
    import areaJosn from './json/area'


    export default JBoot({
        name: 'SelectMoreArea',

        componentName: 'SelectMoreArea',

        registryName: 'select-more-area',

        props: {
            value: Array,

            multiple:true,
            collapse: {
                type: Boolean,
                default(flag) {
                    return flag || false;
                }
            },

            areaDataFilter: {
                type: Function,
                default(source) {
                    return source || [];
                }
            }
        },

        data() {
            return {
                areaSource: areaJosn
            }
        },

        computed: {},

        mounted() {
        },

        methods: {
            createJson(children) {
                children.forEach(item => {
                    item.value = item.value + '000000'
                    if (item.children) {
                        this.createJson(item.children);
                    }
                })
            },
        }
    }).build();
</script>



// WEBPACK FOOTER //
// src/components/SelectMoreArea.vue